import request from './request.js';
import {requestbody} from './request.js'
// 查询审核内容
export async function dgsh_content (params = {

}) {
return await requestbody('audit/query/audit/content', 'post', params)
}
// 审批历史
export async function dgsh_queryAuditStatus (params = {

}) {
return await requestbody('audit/queryAuditStatus', 'post', params)
}

// 新增审核内容弹框中搜索财务数据
export async function dgsh_cwdata (params = {

}) {
return await requestbody('audit/query/caiw/data', 'post', params)
}
// 新增审核内容弹框中搜索报表数据
export async function dgsh_cellDefine (params = {

}) {
return await requestbody('audit/query/shuib/cellDefine', 'post', params)
}
// 新增审核内容弹框中搜索税局数据
export async function dgsh_sjdata (params = {

}) {
return await requestbody('audit/query/shuij/data', 'post', params)
}

// 添加
export async function dgsh_save (params = {

}) {
return await requestbody('audit-content/save', 'post', params)
}
// 修改
export async function dgsh_update (params = {

}) {
return await requestbody('audit-content/update', 'post', params)
}
// 删除
export async function dgsh_delete (params = {

}) {
return await request('audit-content/delete', 'post', params)
}

// 操作
export async function dgsh_completeFlow (params = {

}) {
return await requestbody('oa/flow/completeFlow', 'post', params)
}

// 所有税表（申报种类)
export async function dgsh_queryCompanyShuibDict (params = {

}) {
return await requestbody('sys/queryCompanyShuibDict', 'post', params)
}
// 查询批注
export async function dgsh_getCommentsByIds (params = {

}) {
return await requestbody('/oa/flow/getCommentsByIds', 'get', params)
}
export async function queryAttachmentList(params = {

}) {
    return await requestbody('/manuscript/queryAttachmentList', 'post', params)
}
//上传文件
export async function manuscriptUploadFile(params = {

}) {
    return await request('/manuscript/uploadFile', 'post', params)
}
//保存文件
export async function annexadd(params = {

}) {
    return await requestbody('/manuscript/annex/add', 'post', params)
}
//审核流程查询
export async function auditFlow(params = {

}) {
    return await request('/audit/query/auditFlow', 'post', params)
}
